import { SVGProps, Ref, forwardRef } from 'react';

export const StarHalfFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="m12.536 10.163.136.558c.658 2.713.987 4.07.237 4.604s-1.965-.192-4.393-1.644l-.534-.319-.533.32c-2.428 1.451-3.643 2.177-4.393 1.643-.75-.535-.421-1.891.237-4.604l.141-.583-.437-.367C.838 7.955-.24 7.048.045 6.183s1.705-.977 4.54-1.202l.603-.047.244-.573C6.526 1.787 7.072.5 8 .5s1.475 1.287 2.569 3.86l.243.574.603.047c2.835.225 4.253.337 4.54 1.202s-.793 1.772-2.953 3.588zM8.024 2.19 8 2.15l-.018 9.581 1.252.749c1.254.75 2.064 1.23 2.652 1.478l.039.016v-.002c-.06-.62-.273-1.518-.614-2.92l-.34-1.402 1.13-.951c1.099-.923 1.808-1.524 2.232-1.991-.626-.137-1.57-.215-3.028-.331l-1.45-.115-.575-1.354c-.565-1.33-.93-2.181-1.256-2.718"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
StarHalfFilledSize16Glyph.displayName = 'StarHalfFilledSize16Glyph';
